export const userViewEditPassword = () => ({
  type: 'View Change Password page',
});

export const clickUpdatePassword = () => ({
  type: 'Update user password',
});
